// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"6463cc30a1ef04d5ae78","777":"9a92fa72e55956098cad"}[chunkId] + ".bundle.js";
};